import React from 'react'
import { ErrorMessage } from './error_message'

export const PaymentMethodError = () => <ErrorMessage field="payment_method" />
